module.exports = __webpack_public_path__ + "img/Chris Pringle.58e15d1d.jpg";